<div class="container h-100">
    <div class="row">
        <div class="col-12">
            <div class="error-area text-center">
                <!-- <img src="../../../assets/images/404.svg"> -->
                <img src="../../../assets/images/4O4.gif">
                <h4>We're sorry, the page you requested could not be found. Please go back to the homepage!</h4>
                <p class="lead">
                    <a class="btn btn-primary btn-lg" [routerLink]="" (click)="goToHome()" role="button">Home</a>
                </p>
            </div>
        </div>
    </div>
</div>

